/**
 * @typedef {import('../../../shared/Query').QueryParameters} QueryParameters
 */

import React from 'react';
import { translate } from '../../../Internationalization';
import flags from '../../../../shared/Flags';
import Loading from '../../../../shared/Loading';
import NoContent from '../../../../shared/NoContent';
import useGetAgentContacts from '../../../../Hooks/Agent/Getters/useGetAgentContacts/useGetAgentContacts';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import GenericMoversOverlay from '../ContactAnalysis/Generic/GenericMoversOverlay';
import GenericAvmLeadTable from './Generic/GenericAvmLeadTable';
import Movers from './Movers';
import LeadDateBoard from './LeadDateBoard/LeadDateBoard';

/** @type {QueryParameters} */
const defaultQuery = {
	// Only include contacts with a non-null AVM request date
	'filter[last_avm_request_at][not_null]': true,
	limit: 5,
	// Sort by the AVM request date descending to get latest entries
	'sort[last_avm_request_at]': 'desc',
	// Fallback sorting
	'sort[name.last]': 'asc',
	// eslint-disable-next-line sort-keys
	'sort[name.first]': 'asc',
};

/** @returns {JSX.Element} */
export default function AvmLeadsAnalysis() {
	const gated = useIsGated(flags.agent.mis);
	const agentContacts = useGetAgentContacts(gated.isGated, defaultQuery);

	if (gated.isGettingData || agentContacts.isGettingData) {
		return <Loading />;
	}

	if (gated.isGated) {
		return (
			<section className="my-5">
				<GenericMoversOverlay
					descriptionKey="agent.pages.dashboard.movers.upgraded.Avmlikely_description"
					titleKey="agent.pages.dashboard.movers.labels.Avmlikely"
				/>
				<GenericAvmLeadTable />
			</section>
		);
	}

	if (agentContacts.errorMessage || !agentContacts.data) {
		return (
			<NoContent
				message={translate('agent.pages.contacts.errors.fetch')}
			/>
		);
	}

	return (
		<section className="my-5">
			<Movers moverCounts={agentContacts?.data?.moverCounts} />
			<LeadDateBoard contactList={agentContacts?.data?.contacts} />
		</section>
	);
}
